import { jsx as _jsx } from "react/jsx-runtime";
import BasePlayerButton from "./BasePlayerButton";
const NextButton = ({ disabled, onClick }) => {
    return _jsx(BasePlayerButton, { label: "Pr\u00F3ximo", disabled: disabled, onClick: onClick, iconName: "skip-forward" });
};
NextButton.displayName = "NextButton";
export default NextButton;
